import { MeetingType } from '@module/mdrt-org/shared/utils/enums/meeting-type';

import { getCompanyApprovedMembers } from './get-company-approved-members';
import { getCompanyMeetingRegistrants } from './get-company-meeting-registrants';
import { getCompanyPendingMembers } from './get-company-pending-members';
import { type CompanyListingParams, type CompanyListingResult, CompanyListingType } from './types';

export const PAGE_SIZE = 40;

const COMPANY_LISTING_TYPE_TO_MEETING_TYPE = {
  [CompanyListingType.ANNUAL_MEETING]: MeetingType.AnnualMeeting,
  [CompanyListingType.EDGE_MEETING]: MeetingType.EdgeMeeting,
  [CompanyListingType.GLOBAL_CONFERENCE]: MeetingType.GlobalConferenceMeeting,
} as const;

export const getCompanyListing = async (
  accessToken?: string,
  params?: CompanyListingParams,
  signal?: AbortSignal
): Promise<CompanyListingResult | undefined> => {
  if (!params) return undefined;

  const {
    companyId,
    listType,
    membershipLevel,
    pageNumber,
    pageSize,
    sortAscending,
    sortField,
    year,
  } = params;
  const baseRequest = {
    companyId,
    pageNumber,
    pageSize,
    sortAscending,
    sortField,
    year,
  };

  switch (listType) {
    case CompanyListingType.ANNUAL_MEETING:
    case CompanyListingType.EDGE_MEETING:
    case CompanyListingType.GLOBAL_CONFERENCE: {
      const data = await getCompanyMeetingRegistrants(
        accessToken,
        {
          ...baseRequest,
          meetingType: COMPANY_LISTING_TYPE_TO_MEETING_TYPE[listType],
          membershipLevel,
        },
        signal
      );
      return { data, listType };
    }

    case CompanyListingType.APPROVED_MEMBER: {
      const data = await getCompanyApprovedMembers(
        accessToken,
        { ...baseRequest, membershipLevel },
        signal
      );
      return { data, listType };
    }

    case CompanyListingType.PENDING_MEMBER: {
      const data = await getCompanyPendingMembers(accessToken, baseRequest, signal);
      return { data, listType };
    }

    default: {
      return undefined;
    }
  }
};
